export const getAdemApiServerRegionUrl = (vars, region) => {
  let ademApiServerUrl = vars?.api_server_url;
  if (region === 'cn') {
    ademApiServerUrl = vars?.api_cn_server_url;
  } else if (region === 'gov') {
    ademApiServerUrl = vars?.api_fed_server_url;
  }

  return ademApiServerUrl;
};